import React from 'react';

const BreakSelectionModal = ({ 
  onSelectBreak, 
  onCancel,
  defaultBreakDuration,
  overtimeBreak1Duration,
  overtimeBreak2Duration
}) => {
  const formatDuration = (duration) => {
    const [minutes, seconds] = duration.split(':').map(Number);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg max-w-sm w-full p-6">
        <h3 className="text-lg font-bold mb-3">Select Break Duration</h3>
        <div className="mb-6 text-gray-800">
          Choose which break duration you want to start:
        </div>
        
        <div className="flex flex-col gap-3">
          {/* Break P1→P2 */}
          <button
            onClick={() => onSelectBreak('p1-p2')}
            className="px-4 py-2 rounded bg-amber-500 hover:bg-amber-600 text-black font-bold"
          >
            Break P1→P2 ({formatDuration(defaultBreakDuration)})
          </button>

          {/* Break P2→P3 */}
          <button
            onClick={() => onSelectBreak('p2-p3')}
            className="px-4 py-2 rounded bg-amber-500 hover:bg-amber-600 text-black font-bold"
          >
            Break P2→P3 ({formatDuration(overtimeBreak1Duration)})
          </button>

          {/* Break P3→P4 */}
          <button
            onClick={() => onSelectBreak('p3-p4')}
            className="px-4 py-2 rounded bg-amber-500 hover:bg-amber-600 text-black font-bold"
          >
            Break P3→P4 ({formatDuration(overtimeBreak2Duration)})
          </button>

          {/* Cancel Button */}
          <button
            onClick={onCancel}
            className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300 text-gray-700 font-medium mt-2"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default BreakSelectionModal;
